import React, { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
    ControlledAutocomplete,
    ControlledCheckbox,
    ControlledDatePicker,
    getDefaultSupportTypes,
    IIntakeCompletionForm,
    Section,
    useSelectedOrganisation,
} from '../../../shared';
import { ReferrerInputs } from '../save-support-period-modal/referrer-inputs.component';
import { SupportTypesInfo } from '../support-types-info/support-types-info.component';
import { Stack } from '@mui/material';
import { Appointment } from '../../../shared/enums/appointment.enum';

interface Props {
    form: UseFormReturn<IIntakeCompletionForm>;
}

export const IntakeCreateSupportPeriod: FC<Props> = ({ form }) => {
    const { t } = useTranslation();
    const { organisation } = useSelectedOrganisation();
    const createSupportPeriod = form.watch('createSupportPeriod');
    const defaultSupportTypes = getDefaultSupportTypes(organisation);

    return (
        <Section title={t('supportPeriod')}>
            <ControlledCheckbox name="createSupportPeriod" label={t('createSupportPeriod')} />
            {createSupportPeriod && (
                <Stack spacing={2}>
                    <Stack direction="row" spacing={2} width="800px" alignItems="flex-end">
                        <ControlledDatePicker name="startDate" label={t('startDateLabel')} />
                        <ControlledDatePicker name="endDate" label={t('endDateLabel')} />
                        <ControlledAutocomplete
                            name={`appointment`}
                            label={t('appointmentLabel')}
                            options={Object.values(Appointment)}
                            getOptionLabel={(option) => t(option)}
                            defaultValue={null}
                            sx={{ '.MuiInputBase-root': { py: '4px' } }}
                        />
                    </Stack>

                    <SupportTypesInfo
                        supportTypes={organisation?.supportTypes || []}
                        defaultSupportTypes={defaultSupportTypes}
                    />

                    <ReferrerInputs />
                </Stack>
            )}
        </Section>
    );
};
